// /////////////////////////////////////////////////////////////////
//                          _ooOoo_                               //
//                         o8888888o                              //
//                         88" . "88                              //
//                         (| ^_^ |)                              //
//                         O\  =  /O                              //
//                      ____/`---'\____                           //
//                    .'  \\|     |//  `.                         //
//                   /  \\|||  :  |||//  \                        //
//                  /  _||||| -:- |||||-  \                       //
//                  |   | \\\  -  /// |   |                       //
//                  | \_|  ''\---/''  |   |                       //
//                  \  .-\__  `-`  ___/-. /                       //
//                ___`. .'  /--.--\  `. . ___                     //
//              ."" '<  `.___\_<|>_/___.'  >'"".                  //
//            | | :  `- \`.;`\ _ /`;.`/ - ` : | |                 //
//            \  \ `-.   \_ __\ /__ _/   .-` /  /                 //
//      ========`-.____`-.___\_____/___.-`____.-'========         //
//                           `=---='                              //
//      ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^        //
//                  佛祖保佑       永不宕机     永无BUG              //
//                                                                //
// /////////////////////////////////////////////////////////////////

import React from "react";
import ReactDOM from "react-dom";
import Storage from "store2";
import moment from "moment";
import "moment/locale/zh-cn";
import {
  Provider,
} from "react-keep-alive";
import { LocaleProvider } from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import "./index.css";
import Login from "./components/Login";
import registerServiceWorker from "./registerServiceWorker";
import "./MInput";

moment.locale("zh-cn");
const Authorization = Storage.get("Authorization");
if (Authorization && Authorization !== "") {
  import("./App").then((App) => {
      ReactDOM.render(
        <LocaleProvider locale={zhCN}>
          <Provider>
            <App.default />
          </Provider>
        </LocaleProvider>, document.getElementById("root"));
    }).catch((err) => {
      throw new Error(err);
    });
} else {
  ReactDOM.render(<Login />, document.getElementById("root"));
}
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js